import { Entity } from 'src/app/core/data/schema/entity';

export class Invoice extends Entity {

    public static className = 'Invoice';
    public static endpoint = 'purchases';

    fee: number;
    tax1: number;
    tax2: number;
    tax3: number;
    tax1Name: string;
    tax2Name: string;
    tax3Name: string;
    orgName: string;
    country: string;
    saleEnd: string;
    raffleId: number;
    province: string;
    stripeFee: number;
    raffleName: string;
    onlineTotalSales: number;
    offlineTotalSales: number;

    // client side for easy access
    totalPaid: number;
    taxes: ITaxes[] = [];

    constructor(init?: Partial<Invoice>) {
        super(Invoice.className, null, Invoice.endpoint);
        Object.assign(this, init);
        this.taxes = [
            { name: this.tax1Name?.toUpperCase(), value: this.tax1 },
            { name: this.tax2Name?.toUpperCase(), value: this.tax2 },
            { name: this.tax3Name?.toUpperCase(), value: this.tax3 },
        ];
        this.totalPaid = this.tax1 + this.tax2 + this.tax3 + this.fee;
    }

    static async fetchByRaffle(raffleId: number) {
        return await super.fetchArray(Invoice, null, `raffle/${raffleId}/invoices`);
    }

    static async fetch() {
        return await super.fetchArray(Invoice, 'purchases', 'invoices');
    }

    static async load(invoiceId: number) {
        return await super.getById(Invoice, invoiceId);
    }
}

export interface ITaxes {
    name: string;
    value: number;
}